(() => {
  const list = document.querySelector('.ritual-directions');
  if (!list) return;
  const steps = [...list.children];
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  let timer;
  let visible = false;
  function clear() {
    clearTimeout(timer);
    steps.forEach(step => step.classList.remove('ritual-current'));
  }
  function play() {
    clear();
    if (!visible || reduced.matches || document.hidden) return;
    let index = 0;
    function advance() {
      steps.forEach(step => step.classList.remove('ritual-current'));
      if (index >= steps.length) {
        timer = setTimeout(play, 700);
        return;
      }
      steps[index++].classList.add('ritual-current');
      timer = setTimeout(advance, 1400);
    }
    advance();
  }
  new IntersectionObserver(([entry]) => {
    visible = entry.isIntersecting;
    if (visible) play();
    else clear();
  }, {threshold: 0.35}).observe(list);
  reduced.addEventListener('change', () => { if (reduced.matches) clear(); else play(); });
  document.addEventListener('visibilitychange', () => { if (document.hidden) clear(); else play(); });
})();
